import * as DB from "@/api/common.js"
import { request as Require } from "@/utils/require.js"
import { Toast } from "vant"

const state = () => ({})

const mutations = {
  setIsDDSchool(state, bool) {
    state.isDDSchool = bool
  },
}

const actions = {
  async ossToken(context, params) {
    const r = await Require({
      api: DB.ossToken,
      params,
    })
    if (r.success) {
      return {
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  async uploadOSS({ dispatch, rootState }, { file, moduleName }) {
    if (!file || !file.name) {
      Toast.fail("文件名不能为空！")
      return
    }
    if (!moduleName) {
      Toast.fail("模块名不能为空！")
      return
    }
    let fileNameArr = file.name.split(".")
    let fileName =
      new Date().getTime() + "." + fileNameArr[fileNameArr.length - 1]
    let schoolCode = rootState.schoolCode
    let imgNames = `assets/${schoolCode}/${moduleName}/${fileName}`
    let fileSaveParams = {
      schoolCode,
      name: fileName,
      size: file.size / 1024,
      sizeUnits: "k",
      url: imgNames,
    }
    let fileInfoSave = await dispatch("fileSave", fileSaveParams)
    const ossobj = await dispatch("ossToken", { schoolCode })
    const OSS = require("ali-oss")
    const client = new OSS({
      region: "oss-cn-hangzhou",
      endpoint: "https://oss-cn-hangzhou.aliyuncs.com",
      accessKeyId: ossobj.data.accessKeyId, // 你的ak
      accessKeySecret: ossobj.data.accessKeySecret, // 你的secret
      stsToken: ossobj.data.securityToken, // 这里我暂时没用，注销掉
      bucket: ossobj.data.bucketName, // 你的oss名字
    })

    await client.put(imgNames, file)
    return {
      success: true,
      data: {
        id: fileInfoSave.data,
        name: file.name,
        url: imgNames,
      },
    }
  },
  async fileSave(context, params) {
    const r = await Require({
      api: DB.fileSave,
      params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  async fileInfo(context, params) {
    const r = await Require({
      api: DB.fileInfo,
      params,
    })
    if (r.success) {
      return {
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  async faceCheck(context, params) {
    const r = await Require({
      api: DB.faceCheck,
      params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  async treeAndAllUser(context, params) {
    const r = await Require({
      api: DB.treeAndAllUser,
      params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  async allTeacherAndTree(context, params) {
    const r = await Require({
      api: DB.allTeacherAndTree,
      params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  async allTeacherAndTreePost(context, params) {
    const r = await Require({
      api: DB.allTeacherAndTreePost,
      params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
